module.exports = __webpack_public_path__ + "static/media/Grassi-2015-Cab.af3ca585.jpg";